import { createFileRoute } from "@tanstack/react-router";

import { MenusHubPage, menusQuery } from "@/components/hubs/MenusHubPage";
import { buildHreflangLinks, buildLocaleMeta, SITE_ORIGIN } from "@/lib/i18n-paths";

const PATH = "/fi/menus";
const TITLE = 'Ravintoloiden ruokalistat Suomessa — annokset ja hinnat | what Finland';
const DESC = 'Selaa suomalaisten ravintoloiden, kahviloiden ja baarien julkaistuja ruokalistoja keittiön, hintatason ja alueen mukaan.';

export const Route = createFileRoute("/fi/menus/")({
  loader: ({ context }) => context.queryClient.ensureQueryData(menusQuery),
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { property: "og:url", content: `${SITE_ORIGIN}${PATH}` },
      ...buildLocaleMeta("fi"),
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: `${SITE_ORIGIN}${PATH}` }, ...buildHreflangLinks(PATH)],
  }),
  component: () => <MenusHubPage locale="fi" />,
});
